import { NavigationHookAfter, RouteLocationNormalized } from 'vue-router';
import { useAppFolderDetailStore } from '~/stores/appFolderDetail';
import { useCategoryDetailStore } from '~/stores/categoryDetail';
import { useCategoryItemConfigStore } from '~/stores/categoryItemConfig';
import { useCategoryItemSideMenuStore } from '~/stores/categoryItemSideMenu';
import { useCategoryTreeStore } from '~/stores/categoryTree';
import { useDemandCartStore } from '~/stores/demandCart';
import { useDemandDetailStore } from '~/stores/demandDetail';
import { useDemandDraftDetailStore } from '~/stores/demandDraftDetail';
import { useOrderCartStore } from '~/stores/orderCart';
import { useOrderDetailStore } from '~/stores/orderDetail';
import { useOrderDraftDetailStore } from '~/stores/orderDraftDetail';
import { usePartnerDetailStore } from '~/stores/partnerDetail';
import { useReclamationDetailStore } from '~/stores/reclamationDetail';

const after: NavigationHookAfter = (to) => {
    resetPartnerDetailStore(to);
    resetReclamationDetailStore(to);
    resetAppFolderDetailStore(to);
    resetOrderDetailStore(to);
    resetOrderDraftDetailStore(to);
    resetOrderCartStore(to);
    resetCategoryTreeStore(to);
    resetCategoryDetailStore(to);
    resetCategoryItemConfigStore(to);
    resetCategoryItemSideMenuStore(to);
    resetDemandDetailStore(to);
    resetDemandDraftDetailStore(to);
    resetDemandCartStore(to);
};

const resetPartnerDetailStore = (to: RouteLocationNormalized) => {
    if (!to.name?.toString().startsWith('admin-partners-id') && !to.name?.toString().startsWith('profile')) {
        usePartnerDetailStore().reset();
    }
};

const resetReclamationDetailStore = (to: RouteLocationNormalized) => {
    if (!to.name?.toString().startsWith('service-calls')) {
        useReclamationDetailStore().reset();
    }
};

const resetAppFolderDetailStore = (to: RouteLocationNormalized) => {
    if (!to.name?.toString().startsWith('admin-documents') && !to.name?.toString().startsWith('documents')) {
        useAppFolderDetailStore().reset();
    }
};

const resetOrderDraftDetailStore = (to: RouteLocationNormalized) => {
    if (!to.name?.toString().startsWith('orders-id')) {
        useOrderDraftDetailStore().reset();
    }
};

const resetOrderDetailStore = (to: RouteLocationNormalized) => {
    if (!to.name?.toString().startsWith('orders-id')) {
        useOrderDetailStore().reset();
    }
};

const resetOrderCartStore = (to: RouteLocationNormalized) => {
    if (!to.name?.toString().startsWith('orders-new') && !to.name?.toString().startsWith('orders-id-new')) {
        useOrderCartStore().reset();
    }
};

const resetDemandDraftDetailStore = (to: RouteLocationNormalized) => {
    if (!to.name?.toString().startsWith('demands-id')) {
        useDemandDraftDetailStore().reset();
    }
};

const resetDemandDetailStore = (to: RouteLocationNormalized) => {
    if (!to.name?.toString().startsWith('demands-id')) {
        useDemandDetailStore().reset();
    }
};

const resetDemandCartStore = (to: RouteLocationNormalized) => {
    if (!to.name?.toString().startsWith('demands-new') && !to.name?.toString().startsWith('demands-id-new')) {
        useDemandCartStore().reset();
    }
};

const resetCategoryTreeStore = (to: RouteLocationNormalized) => {
    if (
        !to.name?.toString().startsWith('orders-new') &&
        !to.name?.toString().startsWith('orders-id-new') &&
        !to.name?.toString().startsWith('demands-new') &&
        !to.name?.toString().startsWith('demands-id-new')
    ) {
        useCategoryTreeStore().reset();
    }
};

const resetCategoryDetailStore = (to: RouteLocationNormalized) => {
    if (
        !to.name?.toString().startsWith('orders-new-categories-catid') &&
        !to.name?.toString().startsWith('orders-id-new-categories-catid') &&
        !to.name?.toString().startsWith('demands-new-categories-catid') &&
        !to.name?.toString().startsWith('demands-id-new-categories-catid') &&
        !to.name?.toString().startsWith('orders-new-categories-sale-catid') &&
        !to.name?.toString().startsWith('orders-id-new-categories-sale-catid') &&
        !to.name?.toString().startsWith('demands-new-categories-sale-catid') &&
        !to.name?.toString().startsWith('demands-id-new-categories-sale-catid')
    ) {
        useCategoryDetailStore().reset();
    }
};

const resetCategoryItemConfigStore = (to: RouteLocationNormalized) => {
    if (
        !to.name?.toString().startsWith('orders-new-categories-catid-items-itemid') &&
        !to.name?.toString().startsWith('orders-new-categories-catid-lines-lineid') &&
        !to.name?.toString().startsWith('orders-id-new-categories-catid-items-itemid') &&
        !to.name?.toString().startsWith('orders-id-new-categories-catid-lines-lineid') &&
        !to.name?.toString().startsWith('demands-new-categories-catid-items-itemid') &&
        !to.name?.toString().startsWith('demands-new-categories-catid-lines-lineid') &&
        !to.name?.toString().startsWith('demands-id-new-categories-catid-items-itemid') &&
        !to.name?.toString().startsWith('demands-id-new-categories-catid-lines-lineid') &&
        !to.name?.toString().startsWith('orders-new-categories-sale-catid-items-itemid') &&
        !to.name?.toString().startsWith('orders-new-categories-sale-catid-lines-lineid') &&
        !to.name?.toString().startsWith('orders-id-new-categories-sale-catid-items-itemid') &&
        !to.name?.toString().startsWith('orders-id-new-categories-sale-catid-lines-lineid') &&
        !to.name?.toString().startsWith('demands-new-categories-sale-catid-items-itemid') &&
        !to.name?.toString().startsWith('demands-new-categories-sale-catid-lines-lineid') &&
        !to.name?.toString().startsWith('demands-id-new-categories-sale-catid-items-itemid') &&
        !to.name?.toString().startsWith('demands-id-new-categories-sale-catid-lines-lineid')
    ) {
        useCategoryItemConfigStore().reset();
    }
};

const resetCategoryItemSideMenuStore = (to: RouteLocationNormalized) => {
    if (
        !to.name?.toString().startsWith('orders-new') &&
        !to.name?.toString().startsWith('orders-id-new') &&
        !to.name?.toString().startsWith('demands-new') &&
        !to.name?.toString().startsWith('demands-id-new')
    ) {
        useCategoryItemSideMenuStore().reset();
    }
};
export default after;
